export default "__VITE_ASSET__DvB8o0h8__"